export default "__VITE_ASSET__BWmb465B__"